<template>
  <el-button class="elsa-chip"
    v-bind="$attrs"
  >
  <slot/>
  </el-button>
</template>

<script>
export default {
  name: 'Chip'
}
</script>

<style lang="scss" scoped>
@import '../../scss/_colors.scss';

.elsa-chip {
  text-transform: capitalize;
  display: flex;
  flex-direction: row;
  align-items: center;
  font-family: 'SF Pro Display';

  &, &:focus, &:active {
    transition: background 0.2s;
    border: 2px solid $purple;
    box-sizing: border-box;
    border-radius: 8px;
    font-style: normal;
    // font-weight: 600;
    font-size: 18px;
    color: $purple;
    padding: 11px 24px;
  }

  &:hover {
    background-color: $purple;
    border: 2px solid $purple;
    color: $white;
    font-family: 'SF Pro Display';
    box-sizing: border-box;
    // border-radius: 45px;
    color: $white;
    &::v-deep .elsa-icon-edit,
    &::v-deep i::before,
    &::before {
      // filter: brightness(0) invert(1);
    }
  }
}

</style>
